import { useMemo } from "react";
import { ShipmentType } from "entities/shared/shipmentCard.types";
import { useAirCardActions } from "features/AirCardActions";
import { useAirDeleteAllCardsAction } from "features/AirCardActions";
import { useAirUpdateAllCardsAction } from "features/AirCardActions/model/hooks/useAirUpdateAllCardsAction";
import { AirPaymentsModal } from "features/AirPayments";
import { cardToDeleteStore } from "features/CardToDelete";
import { DeleteAllCardsModal, deleteAllCardsModalStore } from "features/DeleteAllCardsModal";
import { filteredCardsStore, useFilterContext } from "features/Filter";
import { OutOfCreditsModal } from "features/OutOfCreditsModal";
import { useParcelCardActions } from "features/ParcelCardActions";
import { useRailCardActions } from "features/RailCardActions/model/hooks/useRailCardActions";
import { useRoadCardActions } from "features/RoadCardActions/model/hooks/useRoadCardActions";
import { useSeaCardActions, useSeaDeleteAllCardsAction } from "features/SeaCardActions";
import { useSeaUpdateAllCardsAction } from "features/SeaCardActions/model/hooks/useSeaUpdateAllCardsAction";
import { SeaPaymentsModal } from "features/SeaPayments";
import { tagsStore, useTagsContext } from "features/Tags";
import { UpdateAllCardsModal, updateAllCardsModalStore } from "features/UpdateAllCardsModal";
// import { UploadFileModal, uploadFileModalStore } from "features/UploadFileModal";
import { AirCardDeleteModal, airCardDeleteModalStore } from "entities/AirCardDeleteModal";
import { airSavedCardStore } from "entities/AirSavedCard";
import { airSearchCardStore } from "entities/AirSearchCard";
import { AppIntegrationApiAccessModal, appStore, RequestLimitWebAppModal } from "entities/App";
import { authStore } from "entities/Auth";
import { ParcelCardDeleteModal, parcelCardDeleteModalStore } from "entities/ParcelCardDeleteModal";
import { RailCardDeleteModal, railCardDeleteModalStore } from "entities/RailCardDeleteModal";
import { RoadCardDeleteModal, roadCardDeleteModalStore } from "entities/RoadCardDeleteModal";
import { SeaCardDeleteModal, seaCardDeleteModalStore } from "entities/SeaCardDeleteModal";
import { searchFilterStore } from "entities/SearchFilter";
import { seaSavedCardStore } from "entities/SeaSavedCard";
import { seaSearchCardStore } from "entities/SeaSearchCard";
import { subscriptionStore } from "entities/Subscription";
import { PlatformIds } from "shared/constants/auth.constants";
import { voidFunc } from "shared/lib/common.lib";
import { useAppDispatch, useAppSelector } from "shared/lib/redux";

type ModalsProps = {
  authData: {
    urlFacebook: string;
    urlGoogle: string;
    urlApple: string;
  };
  platform: number;
};

export const Modals: RFC<ModalsProps> = ({ authData: _authData, platform: platformFromProps }) => {
  const dispatch = useAppDispatch();
  const shipment = useAppSelector(searchFilterStore.selectors.shipment);
  const isAuthenticated = useAppSelector(authStore.selectors.isAuthenticated);
  const isDeleteAllCardsModalOpened = useAppSelector(deleteAllCardsModalStore.selectors.isDeleteAllCardsModalOpened);
  const isUpdateAllCardsModalOpened = useAppSelector(updateAllCardsModalStore.selectors.isUpdateAllCardsModalOpened);
  const isSeaCardDeleteModalOpened = useAppSelector(seaCardDeleteModalStore.selectors.seaCardDeleteModal);
  const isAirCardDeleteModalOpened = useAppSelector(airCardDeleteModalStore.selectors.airCardDeleteModal);
  const isRailCardDeleteModalOpened = useAppSelector(railCardDeleteModalStore.selectors.railCardDeleteModal);
  const isRoadCardDeleteModalOpened = useAppSelector(roadCardDeleteModalStore.selectors.roadCardDeleteModal);
  const isParcelCardDeleteModalOpened = useAppSelector(parcelCardDeleteModalStore.selectors.parcelCardDeleteModal);
  const platform = useAppSelector(authStore.selectors.platform) ?? platformFromProps;
  const filteredCards = useAppSelector(filteredCardsStore.selectors.filteredCards);
  const seaSavedCards = useAppSelector(seaSavedCardStore.selectors.savedCards);
  const seaSearchCards = useAppSelector(seaSearchCardStore.selectors.searchCards);
  const airSavedCards = useAppSelector(airSavedCardStore.selectors.savedCards);
  const airSearchCards = useAppSelector(airSearchCardStore.selectors.searchCards);
  const cardsByTags = useAppSelector(tagsStore.selectors.cardsByTags);
  const cardToDelete = useAppSelector(cardToDeleteStore.selectors.cardToDelete);
  const activePaymentModal = useAppSelector(subscriptionStore.selectors.activePaymentModal);
  const appIntegrationHasApiAccess = useAppSelector(appStore.selectors.appIntegrationHasApiAccess);
  const appIntegrationRequestLimitReached = useAppSelector(appStore.selectors.appIntegrationRequestLimitReached);
  const webAppRequestLimitReached = useAppSelector(appStore.selectors.webAppRequestLimitReached);
  const { filter, isAirFilter, isSeaFilter, setAllStatuses } = useFilterContext();
  const { refreshTags } = useTagsContext();

  const { isSeaCardDeleting, deleteSeaCardModalHandler, cancelSeaCardDeleting } = useSeaCardActions({
    cardToDelete: cardToDelete,
    removeFilteredCardAction: (card) => ({
      type: filteredCardsStore.actions.removeFilteredCardAction.type,
      payload: card,
    }),
    removeCardByTagAction: (card) => ({
      type: tagsStore.actions.removeCardByTagAction.type,
      payload: card,
    }),
    refreshTags,
  });

  const { isAirCardDeleting, deleteAirCardModalHandler, cancelAirCardDeleting } = useAirCardActions({
    cardToDelete: cardToDelete,
    removeFilteredCardAction: (card) => ({
      type: filteredCardsStore.actions.removeFilteredCardAction.type,
      payload: card,
    }),
    removeCardByTagAction: (card) => ({
      type: tagsStore.actions.removeCardByTagAction.type,
      payload: card,
    }),
    refreshTags,
  });

  const { isRailCardDeleting, deleteRailCardModalHandler, cancelRailCardDeleting } = useRailCardActions({
    cardToDelete: cardToDelete,
    // removeFilteredCardAction: (card) => ({
    //   type: filteredCardsStore.actions.removeFilteredCardAction.type,
    //   payload: card,
    // }),
    // removeCardByTagAction: (card) => ({
    //   type: tagsStore.actions.removeCardByTagAction.type,
    //   payload: card,
    // }),
    // refreshTags,
  });

  const { isRoadCardDeleting, deleteRoadCardModalHandler, cancelRoadCardDeleting } = useRoadCardActions({
    cardToDelete: cardToDelete,
    // removeFilteredCardAction: (card) => ({
    //   type: filteredCardsStore.actions.removeFilteredCardAction.type,
    //   payload: card,
    // }),
    // removeCardByTagAction: (card) => ({
    //   type: tagsStore.actions.removeCardByTagAction.type,
    //   payload: card,
    // }),
    // refreshTags,
  });

  const { isParcelCardDeleting, deleteParcelCardModalHandler, cancelParcelCardDeleting } = useParcelCardActions({
    cardToDelete: cardToDelete,
    // removeFilteredCardAction: (card) => ({
    //   type: filteredCardsStore.actions.removeFilteredCardAction.type,
    //   payload: card,
    // }),
    // removeCardByTagAction: (card) => ({
    //   type: tagsStore.actions.removeCardByTagAction.type,
    //   payload: card,
    // }),
    // refreshTags,
  });

  const { deleteAllSeaCards } = useSeaDeleteAllCardsAction({
    filteredCards,
    seaSavedCards,
    seaSearchCards,
    cardsByTags,
    closeDeleteAllCardsModal: () => {
      dispatch(deleteAllCardsModalStore.actions.closeDeleteAllCardsModalAction());
    },
    filter,
    isSeaFilter,
    setAllStatuses,
    actions: {
      appendFilteredCardsAction: filteredCardsStore.actions.appendFilteredCardsAction,
      appendSavedCardsAction: seaSavedCardStore.actions.appendSavedCardsAction,
      removeFilteredCardAction: filteredCardsStore.actions.removeFilteredCardAction,
      removeCardByTagAction: tagsStore.actions.removeCardByTagAction,
      removeSavedCardAction: seaSavedCardStore.actions.removeSavedCardAction,
      removeSearchCardAction: seaSearchCardStore.actions.removeSearchCardAction,
      refreshTags,
    },
  });

  const { deleteAllAirCards } = useAirDeleteAllCardsAction({
    filteredCards,
    airSavedCards,
    airSearchCards,
    cardsByTags,
    closeDeleteAllCardsModal: () => {
      dispatch(deleteAllCardsModalStore.actions.closeDeleteAllCardsModalAction());
    },
    filter,
    isAirFilter,
    setAllStatuses,
    actions: {
      appendFilteredCardsAction: filteredCardsStore.actions.appendFilteredCardsAction,
      appendSavedCardsAction: airSavedCardStore.actions.appendSavedCardsAction,
      removeFilteredCardAction: filteredCardsStore.actions.removeFilteredCardAction,
      removeCardByTagAction: tagsStore.actions.removeCardByTagAction,
      removeSavedCardAction: airSavedCardStore.actions.removeSavedCardAction,
      removeSearchCardAction: airSearchCardStore.actions.removeSearchCardAction,
      refreshTags,
    },
  });

  const deleteAllCards = useMemo(() => {
    switch (shipment) {
      case ShipmentType.SEA:
        return deleteAllSeaCards;
      case ShipmentType.AIR:
        return deleteAllAirCards;
      default:
        return voidFunc;
    }
  }, [shipment, deleteAllSeaCards, deleteAllAirCards]);

  const { updateAllSeaCards, canCloseUpdateAllSeaCardsModal, seaProgress, seaResults, seaResetState } =
    useSeaUpdateAllCardsAction({
      filteredCards,
      seaSavedCards,
      cardsByTags,
      closeUpdateAllCardsModal: () => {
        dispatch(updateAllCardsModalStore.actions.closeUpdateAllCardsModalAction());
      },
      updateFilteredCards: (response) => ({
        type: filteredCardsStore.actions.updateFilterCardAction.type,
        payload: response,
      }),
    });

  const { updateAllAirCards, canCloseUpdateAllAirCardsModal, airProgress, airResults, airResetState } =
    useAirUpdateAllCardsAction({
      filteredCards,
      airSavedCards,
      cardsByTags,
      closeUpdateAllCardsModal: () => {
        dispatch(updateAllCardsModalStore.actions.closeUpdateAllCardsModalAction());
      },
      updateFilteredCards: (response) => ({
        type: filteredCardsStore.actions.updateFilterCardAction.type,
        payload: response,
      }),
    });

  const updateAllCards = useMemo(() => {
    switch (shipment) {
      case ShipmentType.SEA:
        return {
          updateAllCards: updateAllSeaCards,
          canCloseUpdateAllCardsModal: canCloseUpdateAllSeaCardsModal,
          progress: seaProgress,
          results: seaResults,
          resetState: seaResetState,
        };
      case ShipmentType.AIR:
        return {
          updateAllCards: updateAllAirCards,
          canCloseUpdateAllCardsModal: canCloseUpdateAllAirCardsModal,
          progress: airProgress,
          results: airResults,
          resetState: airResetState,
        };
      default:
        return {
          updateAllCards: voidFunc,
          canCloseUpdateAllCardsModal: false,
          progress: { total: 0, current: 0 },
          results: [],
          resetState: voidFunc,
        };
    }
  }, [shipment, updateAllSeaCards, updateAllAirCards]);

  const PaymentsModal = useMemo(() => {
    switch (shipment) {
      case ShipmentType.SEA:
        return <SeaPaymentsModal />;
      case ShipmentType.AIR:
        return <AirPaymentsModal />;
      default:
        return null;
    }
  }, [shipment]);

  return (
    <>
      {isAuthenticated && isDeleteAllCardsModalOpened && <DeleteAllCardsModal deleteAllCards={deleteAllCards} />}
      {isAuthenticated && isUpdateAllCardsModalOpened && (
        <UpdateAllCardsModal
          updateAllCards={updateAllCards.updateAllCards}
          canCloseModal={updateAllCards.canCloseUpdateAllCardsModal}
          progress={updateAllCards.progress}
          results={updateAllCards.results}
          resetState={updateAllCards.resetState}
        />
      )}
      {isSeaCardDeleteModalOpened && (
        <SeaCardDeleteModal
          deleteCardModalHandler={deleteSeaCardModalHandler}
          cancelDeletingSavedCard={cancelSeaCardDeleting}
          isSavedCardDeleting={isSeaCardDeleting}
        />
      )}

      {isAirCardDeleteModalOpened && (
        <AirCardDeleteModal
          deleteCardModalHandler={deleteAirCardModalHandler}
          cancelDeletingSavedCard={cancelAirCardDeleting}
          isSavedCardDeleting={isAirCardDeleting}
        />
      )}

      {isRailCardDeleteModalOpened && (
        <RailCardDeleteModal
          deleteCardModalHandler={deleteRailCardModalHandler}
          cancelDeletingSavedCard={cancelRailCardDeleting}
          isSavedCardDeleting={isRailCardDeleting}
        />
      )}

      {isRoadCardDeleteModalOpened && (
        <RoadCardDeleteModal
          deleteCardModalHandler={deleteRoadCardModalHandler}
          cancelDeletingSavedCard={cancelRoadCardDeleting}
          isSavedCardDeleting={isRoadCardDeleting}
        />
      )}

      {isParcelCardDeleteModalOpened && (
        <ParcelCardDeleteModal
          deleteCardModalHandler={deleteParcelCardModalHandler}
          cancelDeletingSavedCard={cancelParcelCardDeleting}
          isSavedCardDeleting={isParcelCardDeleting}
        />
      )}

      {activePaymentModal && PaymentsModal}
      <AppIntegrationApiAccessModal
        accessDenied={!appIntegrationHasApiAccess}
        requestLimitReached={appIntegrationRequestLimitReached}
      />
      {/* Opens itself when any request is refused by the company's plan. */}
      <OutOfCreditsModal />
      {webAppRequestLimitReached && (
        <RequestLimitWebAppModal shipment={shipment} platformId={platform ?? PlatformIds.com} />
      )}
      {/* Upload file modal disabled for now */}
      {/*
      {isAuthModalVisible && <AuthModal authData={authData} platform={platform} />}
      */}
    </>
  );
};
